import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { t } from "@/content/site";
import { buildHead, homeOfferCatalogLD, faqLD, sharedOG } from "@/content/seo";

export const Route = createFileRoute("/pt/")({
  component: () => <SitePage lang="pt" />,
  head: () => {
    const head = buildHead({
      lang: "pt",
      path: "/pt",
      title: t.pt.seo.title,
      description: t.pt.seo.description,
      keywords:
        "passeios de barco Vilamoura, Gruta de Benagil, charter iate Vilamoura, passeios de barco Algarve, iate privado Vilamoura, cruzeiro pôr do sol Vilamoura, observação de golfinhos, Morningstar",
      altPath: { en: "/", pt: "/pt" },
      extraScripts: [
        { type: "application/ld+json", children: JSON.stringify(homeOfferCatalogLD("pt")) },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    });
    return {
      ...head,
      links: [
        ...head.links,
        { rel: "preload", as: "image", href: sharedOG.image, fetchpriority: "high" } as any,
      ],
    };
  },
});